module.exports = __webpack_public_path__ + "img/318.df425c0d.png";